// extracted by mini-css-extract-plugin
module.exports = {"form":"SalesFilter_form__1Vwl-","select":"SalesFilter_select__mEki4"};